/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserContactInformationQueryVariables = Exact<{
  userId: string;
}>;


export type GetUserContactInformationQuery = { getUserContactInformation: { email: string | null, mobilePhoneNumber: string | null, landlinePhoneNumber: string | null } | null };


export const GetUserContactInformationDocument = /*#__PURE__*/ gql`
    query GetUserContactInformation($userId: uuid!) {
  getUserContactInformation(userId: $userId) {
    email
    mobilePhoneNumber
    landlinePhoneNumber
  }
}
    `;

/**
 * __useGetUserContactInformationQuery__
 *
 * To run a query within a React component, call `useGetUserContactInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContactInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContactInformationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserContactInformationQuery(baseOptions: Apollo.QueryHookOptions<GetUserContactInformationQuery, GetUserContactInformationQueryVariables> & ({ variables: GetUserContactInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>(GetUserContactInformationDocument, options);
      }
export function useGetUserContactInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>(GetUserContactInformationDocument, options);
        }
// @ts-ignore
export function useGetUserContactInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>;
export function useGetUserContactInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserContactInformationQuery | undefined, GetUserContactInformationQueryVariables>;
export function useGetUserContactInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>(GetUserContactInformationDocument, options);
        }
export type GetUserContactInformationQueryHookResult = ReturnType<typeof useGetUserContactInformationQuery>;
export type GetUserContactInformationLazyQueryHookResult = ReturnType<typeof useGetUserContactInformationLazyQuery>;
export type GetUserContactInformationSuspenseQueryHookResult = ReturnType<typeof useGetUserContactInformationSuspenseQuery>;
export type GetUserContactInformationQueryResult = Apollo.QueryResult<GetUserContactInformationQuery, GetUserContactInformationQueryVariables>;